import { useMemo } from "react"
import type { OperationContext } from "urql"
import { useQuery } from "urql"

import type { Query, Salesman, SalesmanListSuccess } from "@/graphql/codegen/graphql"
import { GetSalesmanListDocument } from "@/graphql/codegen/graphql"

interface UseSalesPersonReturn {
  salesPersons: Salesman[]
  fetching: boolean
  executeQuery: (opts?: Partial<OperationContext>) => void
}

const useGetSalesPerson = (): UseSalesPersonReturn => {
  const [{ data, fetching }, executeQuery] = useQuery<Pick<Query, "salesman">>({
    query: GetSalesmanListDocument,
  })

  const salesPersons: Salesman[] = useMemo(() => {
    return ((data?.salesman?.list as SalesmanListSuccess)?.salesmen as Salesman[]) ?? []
  }, [data])

  return {
    salesPersons,
    fetching,
    executeQuery,
  }
}

export default useGetSalesPerson
